<link
  rel="stylesheet"
  href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
  integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
  crossorigin="anonymous"
/>
<div class="container">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <a class="navbar-brand" href="/">
            <img src="/assets/img/paikese-pizza-logo-100px.png" class="brand" alt="" width="100" height="123">
          </a>
          <button class="navbar-toggler menu-button" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse menu-items" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" routerLink="createpizza" routerLinkActive="active">Create your pizza</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="pizzas" routerLinkActive="active">Pizzas</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="about-us" routerLinkActive="active">About us</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="contact" routerLinkActive="active">Contact</a>
          </li>
          <li class=""nav-item>
            <a routerLink="/cart" class="button fancy-button">
              <i class="fas fa-shopping-cart"></i>
</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>

